import React from 'react'
import Styled from 'styled-components'
import * as utils from './../../scripts/utils'

class ComponentProps extends React.Component {
  constructor(props) {
    super(props)

    this.parseDescription = this.parseDescription.bind(this)
    this.parseType = this.parseType.bind(this)
    this.parseDefaultValue = this.parseDefaultValue.bind(this)
  }

  parseDescription(description) {
    return description || '-'
  }

  parseType(type) {
    if (!type) {
      return '-'
    }

    let name = utils.capitalizeFirst(type.name)

    if (type.name !== 'union') {
        return (<code className="mr-1">{name}</code>)
    }

    return type.value.map(function(val, index) {
        if (val.name !== 'arrayOf') {
            return (<code key={index} className="mr-1">{utils.capitalizeFirst(val.name)}</code>)
        }

        return (<code key={index} className="mr-1">{`Array[${utils.capitalizeFirst(val.value.name)}]`}</code>)
    })
  }

  parseDefaultValue(defaultValue) {
    if (!defaultValue) {
        return '-'
    }

    return (<code>{defaultValue.value}</code>)
  }

  render() {
    const propsRows = []

    var i = 0
    for (const propName in this.props.propsData) {
        const {
          defaultValue,
          description,
          required,
          type
        } = this.props.propsData[propName]

        const pDescription = this.parseDescription(description)
        const pType = this.parseType(type)
        const pDefault = this.parseDefaultValue(defaultValue)

        propsRows.push(
            <tr key={i}>
                <td data-label="Prop"><strong>{ propName }</strong></td>
                <td data-label="Description">{ pDescription }</td>
                <td data-label="Type">{ pType }</td>
                <td data-label="Default">{ pDefault }</td>
                <td data-label="Required">{ required ? 'Yes' : 'No' }</td>
            </tr>
        )

        i++
    }

    return (
        <PropsWrapper>
            { !this.props.subcomponent && <h2>Props</h2> }
            { !this.props.subcomponent && <p>The following props are available for the <code>{this.props.componentName}</code> component.</p> }
            <table className="meta-table">
                <thead>
                    <tr>
                        <th>Prop</th>
                        <th>Description</th>
                        <th>Type</th>
                        <th>Default</th>
                        <th>Required</th>
                    </tr>
                </thead>
                <tbody>
                  { propsRows }
                </tbody>
            </table>
        </PropsWrapper>
    )
  }
}

export default ComponentProps

const PropsWrapper = Styled.div`
    > h1, > h2, > h3, > h4, > h5, > h6 {
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
        font-weight: 600;
    }

    > h1 {
        margin-bottom: 30px;
    }

    > h2 {
        font-size: 24px;
        letter-spacing: 0;
    }

  .meta-table {
      width: 100%;
      background: #fff;
      box-shadow: 0 3px 8px 0 rgba(0,0,0,0.03);
      font-size: 13px;

      thead {
          background: #f5f8fa;
          color: #586e8d;
      }

      th, td {

          padding: 10px 15px;
      }

      tr {
          border-radius: 10px;
          border: 1px solid #d4dadf;
      }
  }

  @media (max-width: 780px) {
      .meta-table {
          border-collapse: collapse;
          margin: 0;
          padding: 0;
          width: 100%;
          table-layout: fixed;
          background: transparent;
          box-shadow: none;
      }

      .meta-table caption {
          font-size: 1.5em;
          margin: .5em 0 .75em;
      }

      .meta-table tr {
          padding: .35em;
          background: #fff;
          box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
      }

      .meta-table th,
      .meta-table td {
          padding: .625em;
          text-align: right !important;
      }

      .meta-table th {
          font-size: .85em;
          letter-spacing: .1em;
          text-transform: uppercase;
      }

      .meta-table {
          border: 0;
      }

      .meta-table caption {
          font-size: 1.3em;
      }

      .meta-table thead {
          border: none;
          clip: rect(0 0 0 0);
          height: 1px;
          margin: -1px;
          overflow: hidden;
          padding: 0;
          position: absolute;
          width: 1px;
      }

      .meta-table tr {
          display: block;
          margin-bottom: .625em;
      }

      .meta-table td {
          display: block;
          font-size: .8em;
          text-align: right;
      }

      .meta-table td::before {
          content: attr(data-label);
          float: left;
          font-weight: bold;
          text-transform: uppercase;
      }

      .meta-table td:last-child {
          border-bottom: 0;
      }
  }
`
